import { computed } from 'mobx';

const bind = () =>
  function(instance, methodName, descriptor) {
    const context = this;
    const get = descriptor.get;
    descriptor.get = function() {
      return get.call(context);
    };
  };

export default function compute(instance, methodName, descriptor = Object.getOwnPropertyDescriptor(instance, methodName), { disableCompute } = {}) {
  let value = instance[methodName] || (descriptor.initializer && descriptor.initializer.call(this));
  Object.keys(value).forEach(key => {
    const descriptor = Object.getOwnPropertyDescriptor(value, key);
    !disableCompute && computed(value, key, descriptor);
    bind().apply(instance, [value, key, descriptor]);
    Object.defineProperty(value, key, descriptor);
  });
  return {
    get() {
      return value;
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/vm-component/compute/index.js